import {Component, OnInit, Inject, PLATFORM_ID} from '@angular/core';
import {EventsService} from '../../events.service';
import {Router, ActivatedRoute, NavigationEnd} from '@angular/router';
import {GlobalService} from '../../../global.service';
import {FacebookService, InitParams, UIResponse, UIParams, LoginOptions, LoginResponse} from "ngx-facebook";
import {isPlatformBrowser} from "@angular/common";
import {NotificationsService} from "angular2-notifications";
import {Title} from "@angular/platform-browser";


@Component({
  selector: 'app-halloween-nights',
  templateUrl: './halloween-nights.component.html',
  styleUrls: ['./halloween-nights.component.css']
})
export class halloweenNights implements OnInit {

  mobileView: boolean = false;

  constructor(@Inject(PLATFORM_ID) private platformId: Object, private router: Router,
              private notify: NotificationsService, private fb: FacebookService,
              private activeRoute: ActivatedRoute, public eventService: EventsService,
              public globalService: GlobalService, private titleService:Title) {
    this.titleService.setTitle('halloween-nights')
    if (globalService.isBrwoser) {
      if (window.screen.width < 768) {
        this.mobileView = true;
      }
    }

    if (isPlatformBrowser(this.platformId)) {
      let fbParams: InitParams = {
        appId: '1692568150989522',
        xfbml: true,
        version: 'v3.3'
      }
      this.fb.init(fbParams);
    }
  }

  ngOnInit() {
    if (this.router.url.split('/').length < 3)
      this.router.navigateByUrl('/halloween-nights/fortnite');
  }


  getBanner(game) {
    if (game == 'home') {
      if (this.mobileView)
        return '../../../../assets/img/insomnia/insomnia-banner-mobile.jpg';
      else
        return '../../../../assets/img/insomnia/insomnia-banner.jpg';
    } else {
      if (this.mobileView)
        return '../../../../assets/img/insomnia/games/' + this.eventService.insomniaGame + '/banner-mobile.jpg';
      else
        return '../../../../assets/img/insomnia/games/' + this.eventService.insomniaGame + '/banner.jpg';
    }
  }


}

